













import ApiSearch from "@/components/apiSearch/components/ApiSearch.vue";

import Vue from "vue";
import { ApiSearchColumn } from "@/components/apiSearch/models/ApiSearch";
import PartDTO from "@/modules/part/models/PartDTO";
import { t } from "@/plugins/i18n";

export default Vue.extend({
  components: { ApiSearch },

  props: {
    initId: Number,
    invGroupId: { type: Number, default: 1 },
    disabled: {type: Boolean, default: false},
  },

  methods: {
    selected(part: PartDTO): void {
      this.$emit("change", part);
    },
  },

  computed: {
    id(): number {
      return this.initId ?? 1;
    },

    columns: (): ApiSearchColumn[] => [
      { field: "code", title: t("Cikkszam") },
      { field: "name", title: t("Megnevezes") },
      { field: "group", title: t("Cikkcsoport") },
      { field: "mainGroup", title: t("Focsoport") },
      { field: "subGroup", title: t("Alcsoport") },
      { field: "extCode", title: t("KulsoKod") },
    ],
  },
});
